import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { ValueDescription } from '../../../../../card/value-description/value-description';
import Skeleton from '../../../../skeleton';
import { IconArrowRightWide } from '../../../../../icons/arrow-right-wide';
import { IconButton } from '../../../../../icon/button/icon-button';
import { CardTitle } from '../../../../../card/title/card-title';
import { Stack } from '../../../../../stack/stack';

export const SkeletonDashboardCardsUnrealizedProfit: React.FC = observer(() => {
    const { t } = useTranslation();

    return (
        <div className="relative flex h-full flex-col items-start justify-between overflow-hidden rounded-large bg-body p-[1.6rem] shadow-strong lg:p-[2.2rem]">
            <CardTitle
                title={t('layout.statisticsCard.unrealizedProfit.title')}
                actions={
                    <IconButton
                        icon={<IconArrowRightWide />}
                        variant={'default'}
                        variation={'outlined'}
                        size={'small'}
                    />
                }
            />
            <Stack direction="vertical">
                <Skeleton height={1.9} width={6.5} />
                <ValueDescription
                    padding={'none'}
                    value={<Skeleton height={2.4} width={15} />}
                    description={<Skeleton height={1.3} width={16} />}
                    valueColor={'default'}
                />
            </Stack>
        </div>
    );
});
